import { IMyInputFieldChanged, IMyDateModel, IMyDpOptions } from "mydatepicker";
import { Component, OnInit, ViewChild, Inject, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalComponent } from '../../global/global.component';
import { FilterSettingsModel, IFilter, GridComponent, DataStateChangeEventArgs, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { SearchSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/service/general.service';
import { KeyValue } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonHttpService } from 'src/app/common.service';
import {  AddTypeBO,GetListBasetype,WhereCondition,
  AddNoteBO,GetListBasenote,WhereConditionnote} from './client-notes.modal';
import { ClientNotesService } from './client-notes.service';
import { ClientNotesDateService } from './client-nottes-service';
import { ClientNotesTypeService } from './client-notestype-service';
import { columnWidth } from '../list/list.model';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { DateService } from 'src/app/date.service';
import { ClientBO, functionpermission } from "../client-parent/client-parent.model";
import { ClientHttpService } from "../client-parent/client-parent.service";


@Component({
  selector: 'app-client-notes',
  templateUrl: './client-notes.component.html',
  styleUrls: ['./client-notes.component.scss']
})
export class ClientNotesComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild("pdfNotesList") pdfNotesList;
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('gridnotes') public gridnotes: GridComponent;
  ClientList: any = new ClientBO();
  disabledsavedbutton:boolean=false;
  //@Input() Client:string;
  @Input() Client: ClientBO=  new ClientBO();
  EndDateFilter: any;
  FromDateFilter: any;
  
  noteLst: AddNoteBO[] = []
  addtypeBO: AddTypeBO = new AddTypeBO();
  addnoteBO: AddNoteBO = new AddNoteBO();
  //......................................................................................................................................................... 
  today = new Date();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: false,
    editableDateField: true,
  };
  public myDatePickerOptionsDOB: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: this.today.getFullYear(),
      month: this.today.getMonth() + 1,
      day: this.today.getDate() + 1,
    },
    showClearDateBtn: false,
    editableDateField: true,
  };
// ,................................................................................................................................................................
  initialPage: object;
  filterOptions: FilterSettingsModel;
  public toolbar: ToolbarItems[];
  filter: IFilter;
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  arraycol: any = [];
  ColumnArray: columnWidth[]


  conditionlistnote: WhereConditionnote[] = [];
  conditionDatanote: WhereConditionnote = new WhereCondition();


 
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];

  StatusList: any = [];
  statusListAll: any = [];
  getClient: GetListBasetype = new GetListBasetype();
  getclientnotes: GetListBasenote = new GetListBasenote();
  public datatype: Observable<DataStateChangeEventArgs>;
  public datanotes: Observable<DataStateChangeEventArgs>;
  fp: functionpermission = new functionpermission();

  public state: DataStateChangeEventArgs;
  // .................................................................................................................................................

  constructor( public notesservice:ClientNotesService,public global: GlobalComponent, 
    public generalservice: GeneralService,  public ClientService: ClientHttpService,
    public toasterservice: ToastrService, @Inject(ClientNotesDateService) public clientnotesdateservice: ClientNotesDateService,public datepipe: DatePipe,
    public ngxservice: NgxUiLoaderService,public clientNotesTypeService: ClientNotesTypeService,public dateservice: DateService,) 
  {

   this.datanotes = clientnotesdateservice;

   //this.datatype = clientnotesdateservice;
   }
// .......................................................NG ONIT.................................................................................
  ngOnInit(): void {

    this.filterOptions = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
  
    this.getStatus() ;
    this.getStatusAll() ;

    this.getnotesgrid();
   
    this.getTypeDropDown();
    //this.gettypegrid();
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.getpermission()


  }
  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "Client");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.ClientService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}


  // ............................................................................................................................................
  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'FilterFromDate') {  
        let val = this.dateservice.inputFeildchangeReturnall(event);  
        if (val != undefined) {  
          let element = this.dateservice.inputFeildchangeReturnall(event);  
          this.FromDateFilter  = element;  
        }
  
      }
  
      if (name == 'FilterToDate') {
  
        let val = this.dateservice.inputFeildchangeReturnall(event);
  
        if (val != undefined) {
  
          let element = this.dateservice.inputFeildchangeReturnall(event);
  
          this.EndDateFilter = element;
  
        }
  
      }
  
     
  
  
  
    }


    if (type == "datechanged") {

      if (name == 'FilterFromDate') {
  
        let val = this.dateservice.Datechange(event);
  
        if (val != undefined) {
  
          let element = this.dateservice.Datechange(event);
  
          this.FromDateFilter = element;
  
  
  
        }
  
      }
  
      if (name == 'FilterToDate') {
  
        let val = this.dateservice.Datechange(event);
  
        if (val != undefined) {
  
          let element = this.dateservice.Datechange(event);
  
          this.EndDateFilter = element;
  
        }
  
      }
  
     
  
    }




  }
  ApplyFilter() {

    // if (this.FromDateFilter == null || this.FromDateFilter == '' || this.FromDateFilter == undefined) {
  
    //   this.toasterservice.error("select start date");
  
    //   return;
  
    // }
  
    // else if (this.EndDateFilter == null || this.EndDateFilter == undefined || this.EndDateFilter == '') {
  
    //   this.toasterservice.error("select end date");
  
    //   return;
  
    // }
  
     if ((this.FromDateFilter != null && this.FromDateFilter != undefined && this.FromDateFilter != '')
  
      && (this.EndDateFilter != null && this.EndDateFilter != undefined && this.EndDateFilter != '')) {
  
      if (new Date(this.FromDateFilter).getTime() > new Date(this.EndDateFilter).getTime()) {
  
        this.toasterservice.error("End date should greater than start date");
  
        return;
  
      }
      this.getclientnotes.startDate = this.global.getDateTimeString(this.FromDateFilter)
  
      this.getclientnotes.endDate = this.global.getDateTimeString(this.EndDateFilter)
  
    }
  
   
  
    this.getnotesgrid();
  
  }


  RefreshFilter() {


    this.getclientnotes.field = this.getclientnotes.orderColumn = "notes";
    this.getclientnotes.matchCase = false;
    this.getclientnotes.operator = "startswith";
    this.getclientnotes.value = "";
    this.getclientnotes.type = "string"
    this.EndDateFilter = null;  
    this.FromDateFilter = null;  
    this.getclientnotes.startDate = null; 
    this.getclientnotes.endDate  = null;
    this.getclientnotes.noteTypeId = "00000000-0000-0000-0000-000000000000"
    this.getnotesgrid();
  
  
  
   
  
  }


// =======================Grid Column selector ================ //
show() {
  this.grid.columnChooserModule.openColumnChooser(500, 50);
}

showColumn() {
  this.gridnotes.columnChooserModule.openColumnChooser(500, 50);
}


getStatus() {
  let params = new URLSearchParams();
  params.append("ListCode", "STATUS");
  this.notesservice.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    this.StatusList = data;
    this.addtypeBO.statusLid = this.StatusList.filter(st => st.lovCode == "ACTIVE")[0].id;
  })
}

getStatusAll() {
  let params = new URLSearchParams();
  params.append("listCode", "STATUS");
  this.notesservice.getLov(params).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
    this.statusListAll = data;
    this.getClient.statusLid = this.statusListAll?.filter(s => s.lovName.trim().toUpperCase() == "ACTIVE")[0].id;
    this.statusListAll.push({ id: '00000000-0000-0000-0000-000000000000', lovName: "All" });
    this.gettypegrid();
  })
}

public formatOptions: object

ModelType: any;
TypeCreateupdate(data) {
  this.ModelType=data;
 if(this.ModelType=='new'){
   
    this.addtypeBO = new AddTypeBO();
  
  
 }
 else {
 
    this.ModelType = 'edit';
}
  
}

// ........................................................saveupdate type........................................................//

saveupdatetype(type: string){
  this.disabledsavedbutton=true;
  if(this.addtypeBO.id == '00000000-0000-0000-0000-000000000000' ){
    var saveList: AddTypeBO= JSON.parse(JSON.stringify(this.addtypeBO));
           this.notesservice.saveupdatetype(saveList).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
            this.disabledsavedbutton=false;
        this.toasterservice.success("saved  Successfully","type saved"); 
        document.getElementById("openaddtypemodal").click();
        this.datatype = this.clientNotesTypeService;
         this.gettypegrid();
      },
      err => {
        this.disabledsavedbutton=false;
        this.toasterservice.error(err.error);
        
  });
  }   
  else{
   
    this.notesservice.saveupdatetype(this.addtypeBO).subscribe((data: any) => {
      this.toasterservice.success("update  Successfully","type Updated "); 
      this.disabledsavedbutton=false;
      document.getElementById("openaddtypemodal").click();
      this.datatype = this.clientNotesTypeService;
       this.gettypegrid();
    },
  
    err => {
      this.disabledsavedbutton=false;
      this.toasterservice.error(err.error);
      
  
  });

  }

  
  
  }

  



  // .....................................................typegrid............................................................


  gettypegrid() {

    this.datatype = this.clientNotesTypeService;
    this.clientNotesTypeService.executetype(this.getClient);
     let count = 0;
     this.datatype.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
       count = count + 1;
     })
   }




  // .......................................................type datachangevent.........................................................


  public onActionComplete(args) {

  

    this.getClient.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.getClient.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
  
  }

// ....................................................................................................................................................

type: string = "";
public dataStateChange(state): void {
  this.type = (state.action.requestType).toString();
  if (this.type != "filterchoicerequest") {
    if ((state.sorted || []).length) {
      this.getClient.orderColumn = state.sorted[0].typeName;
      this.getClient.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
    }
  }
  if (this.type == "filtering" && state.action.action != "clearFilter") {
    this.getClient.field = state.action.currentFilterObject.field;
    this.getClient.matchCase = state.action.currentFilterObject.matchCase;
    this.getClient.operator = state.action.currentFilterObject.operator;
    this.getClient.value = state.action.currentFilterObject.value;
  }
  else {
    if (this.type == "filtering" && state.action.action == "clearFilter") {
      this.getClient.field = "typeName";
      this.getClient.matchCase = false;
      this.getClient.operator = "startswith";
      this.getClient.value = "";
    }
  }
  this.gettypegrid();
  if (this.type == "paging" && state.action.name == "actionBegin") {
    if (this.arraycol.length != 0) {
      if (this.arraycol[0].clienttype.Pagesize != state.take) {
        this.arraycol[0].clienttype.Pagesize = state.take
        
        

      }

    }
  }
}



edittype(data)
{
 
 this.addtypeBO=JSON.parse(JSON.stringify(data));
 
 
}
// ..........................................................Delete type..........................................
ContactId:any;

setDeleteId(value) {
  this.ContactId = value;
 
  
}

Delete(){
  
  let param = new URLSearchParams()
  param.append("Id", this.ContactId)
  this.notesservice.delete(param).subscribe((data: any) => {
    this.toasterservice.success("type has been deleted successfully", "type deleted");
    document.getElementById("openModaltype").click();
    this.gettypegrid();
   
  },
    err => {
      this.toasterservice.error(err.error);
    })
   
}


//..... ..............................................save update notes................................................................................

opennewnote() {
   
   
  this.addnoteBO = new AddNoteBO();
  this.addnoteBO.id = "00000000-0000-0000-0000-000000000000";
  this.addnoteBO.date = this.datepipe.transform(new Date(), "yyyy-MM-dd'T'HH:mm")
  this.addnoteBO.user = this.global.logginedUserName
  //this.addnoteBO.multipletype = []

  this.addnoteBO.notes = ""
}

// .....................................................editnotes......................................................................................
notelist:any=[];
editNote(data) {

  console.log(data,"dddddd");
  this.addnoteBO.noteTypeId =data.noteTypeId
  
  this.addnoteBO.id = data.id;
  this.addnoteBO.date = this.datepipe.transform(data.date, "yyyy-MM-dd'T'HH:mm")
  this.addnoteBO.user = this.global.logginedUserName
 this.addnoteBO.notes=data.notes

  
 
}






saveNote() {
 this.disabledsavedbutton=true;
  this.addnoteBO.clientId = this.Client.id
  if (this.addnoteBO.id == '00000000-0000-0000-0000-000000000000') {
  this.notesservice.saveupdatenote(this.addnoteBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    this.disabledsavedbutton=false;
      this.toasterservice.success(
        "Notes  Saved successfully", "Notes  Saved",
 );
 document.getElementById("Addnotes").click()
 this.getnotesgrid();
    },
    err => {
      this.disabledsavedbutton=false;
      this.toasterservice.error(err.error);
      
 });
  }
  else{
    this.notesservice.updatenote(this.addnoteBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.disabledsavedbutton=false;
      this.toasterservice.success(
        "Notes  Updated successfully",
        "Notes  Updated",
      );
      document.getElementById("Addnotes").click()
      this.getnotesgrid();
    },
    err => {
      this.disabledsavedbutton=false;
      this.toasterservice.error(err.error);
      
 });
 }
}

closeTypeModal(){
  document.getElementById("openaddtypemodal").click();
  this.getTypeDropDown();
}
// ....................................Type DROPDOWN..................................................
typedropdown:any;

getTypeDropDown()
{

  this.notesservice.getTypeDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    this.typedropdown = data;
    console.log(data);
})
}
data=[{
  id:0
}]


// ........................................................notes actioncomplete...................................................

public onActionCompletenotes(args) {


  this.getclientnotes.currentpageno = this.grid.pageSettings.currentPage;
  this.getclientnotes.pageitem = this.grid.pageSettings.pageSize;
  if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
    this.getclientnotes.type = args.columnType;
  }
  if(args.requestType == "sorting"){
    if(args.columnName == null || args.columnName == undefined){
      this.getclientnotes.orderColumn = 'notes';
      this.getclientnotes.orderType = 'asc'
    }else{
      this.getclientnotes.orderColumn = (args.columnName != null && args.columnName != undefined)? args.columnName : 'notes';
      this.getclientnotes.orderType = (args.direction == "Ascending")? 'asc' : 'desc';
    }
  }

  this.getclientnotes.currentpageno = this.gridnotes.pageSettings.currentPage;
  this.getclientnotes.pageitem = this.gridnotes.pageSettings.pageSize;
  this.conditionlist = [];
  if (args.requestType === "filtering" && args.action === "filter") {
    args.columns.forEach(element => {
      this.conditionlist.push(element.properties);
    });
  }

}


// ....................................................................................................................................
typenotes: string = "";
public dataStateChangenotes(state): void {
  this.typenotes = (state.action.requestType).toString();
  // if (this.typenotes == 'sorting') {
  //   if ((state.sorted || []).length) {
  //     this.getclientnotes.orderColumn = state.sorted[0].notes;
  //     this.getclientnotes.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
  //   }
  // }
  if (this.typenotes == "filtering" && state.action.action != "clearFilter") {
    this.getclientnotes.field = state.action.currentFilterObject.field;
    this.getclientnotes.matchCase = state.action.currentFilterObject.matchCase;
    this.getclientnotes.operator = state.action.currentFilterObject.operator;
    this.getclientnotes.value = state.action.currentFilterObject.value;
    // if(this.getclientnotes.field == "date"){
    //   this.getclientnotes.type = "datetime";
    //    this.getclientnotes.operator = "equal";
    // }
    if(this.getclientnotes.type == 'number'){
      this.getclientnotes.value = (this.getclientnotes.value != null && this.getclientnotes.value != undefined)
      ? this.getclientnotes.value.toString() : null;
    }
    if(this.getclientnotes.type == "date" || this.getclientnotes.type == "datetime"){
      (!isNaN(Date.parse(this.getclientnotes.value)))
      ? this.global.getDateTimeString(new Date(this.getclientnotes.value)) : null;
    }
  }
  if((this.typenotes == "filtering" && state.action.action == "clearFilter") 
    || (this.getclientnotes.type != 'string' && (this.getclientnotes.value == null  || this.getclientnotes.value == undefined || this.getclientnotes.value == ''))) {
    this.getclientnotes.field = "notes";
    this.getclientnotes.matchCase = false;
    this.getclientnotes.operator = "startswith";
    this.getclientnotes.value = "";
    this.getclientnotes.type = "string"
  }
  this.getnotesgrid();
  if (this.typenotes == "paging" && state.action.noteTypeName == "actionBegin") {
    if (this.arraycol.length != 0) {
      if (this.arraycol[0].clientnotes.Pagesize != state.take) {
        this.arraycol[0].clientnotes.Pagesize = state.take
        
        

      }

    }
  }

 
}

// .....................................................notesgrid............................................................


  getnotesgrid() {
    this.getclientnotes.startDate = (this.FromDateFilter!=null&& this.FromDateFilter!=undefined && this.FromDateFilter!="")?this.global.getDateTimeString(this.FromDateFilter):null
    this.getclientnotes.endDate = (this.EndDateFilter!=null&& this.EndDateFilter!=undefined && this.EndDateFilter!="")?this.global.getDateTimeString(this.EndDateFilter):null

  this.getclientnotes.clientId = this.Client.id
    this.clientnotesdateservice.executenotes(this.getclientnotes);
     let count = 0;
    // this.gridnotes.dataSource = this.data
     this.datanotes.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      console.log(data);
      
     this.noteLst = data.result;
       count = count + 1;
     })
   }


// ..............................................................delete notes...............................................................

  
noteId:any;

noteDeleteId(value) {
  this.noteId = value;
 
  
}


NoteDelete(){
  
  let param = new URLSearchParams()
  param.append("Id", this.noteId)
  this.notesservice.deletenote(param).subscribe((_data: any) => {
    this.toasterservice.success("notes has been deleted successfully", "notes  deleted");
    document.getElementById("openModal2").click();
   this.getnotesgrid();
   
  },
    err => {
      this.toasterservice.error(err.error);
    })
   
}


// ...........................................print...........................................................................
clientname_print: any
clientBOB_print: any
printData() {
  this.ngxservice.start();
    
      (this.pdfNotesList.A4 = true),
        (this.pdfNotesList.portrait = true),
        (this.pdfNotesList.keepTogether = ".prevent-split"),
        (this.pdfNotesList.scale = 0.8),
        this.pdfNotesList.height = 100,
        this.pdfNotesList.margin = { left: "1.2cm", top: "1cm", right: "0.2cm", bottom: "1cm", }
      this.pdfNotesList.padding = { bottom: "50px" };
      
    
      this.pdfNotesList.saveAs(
        "Client-NotesReport" +
        new Date().toLocaleDateString() +
        "-" +
        new Date().toLocaleTimeString()
      );
   
  
    console.log(this.noteLst,"noteLst")

this.ngxservice.stop();


}
closeAddUpdateModal() {
  document.getElementById('cancelmodal').click();
 
}



}

